module.exports = __webpack_public_path__ + "img/sysxf.9ce9c8cd.png";